// /mensajes — conversación del paciente con su kinesiólogo. 1 paciente
// = 1 kine = 1 conversación.
//
// Sprint 3 B5: wire reemplaza mock previo. Reusa <ChatConversation />
// (mismo componente que usa DetallePaciente tab Mensajes — patrón
// shared cierra duplicación entre vista kine y vista paciente).

import { Avatar } from '../components/Avatar';
import { PacienteBottomNav } from '@/app/components/paciente/PacienteBottomNav';
import { ChatConversation } from '../components/patients/ChatConversation';
import { useCurrentPacienteId } from '@/app/components/auth/AuthProvider';
import { useProfilePaciente } from '@/lib/supabase/queries/useProfilePaciente';
import { useMensajesConversacion } from '@/lib/supabase/queries/useMensajesConversacion';
import { useEnviarMensaje } from '@/lib/supabase/queries/useEnviarMensaje';
import { useMarcarLeidos } from '@/lib/supabase/queries/useMarcarLeidos';
import { Loader2 } from 'lucide-react';

export function MensajesPaciente() {
  const pacienteId = useCurrentPacienteId();
  const profile = useProfilePaciente();
  const mensajes = useMensajesConversacion(pacienteId);
  const enviar = useEnviarMensaje();
  const marcar = useMarcarLeidos();

  const kineNombre = profile.data?.kine?.nombre ?? 'tu kinesiólogo';

  return (
    <div className="min-h-screen bg-background flex flex-col transition-colors duration-200">
      <div className="w-full max-w-[480px] mx-auto flex-1 flex flex-col pb-24">
        {/* Header con info del kine */}
        <div className="bg-card border-b border-border p-4 shadow-sm shrink-0">
          {profile.loading ? (
            <div className="flex items-center gap-3 animate-pulse">
              <div className="w-10 h-10 rounded-full bg-muted" />
              <div className="space-y-1.5">
                <div className="h-4 w-32 bg-muted rounded" />
                <div className="h-3 w-20 bg-muted rounded" />
              </div>
            </div>
          ) : (
            <div className="flex items-center gap-3">
              <Avatar name={kineNombre} colorIndex={0} />
              <div>
                <h2 className="font-semibold">{kineNombre}</h2>
                <p className="text-xs text-muted-foreground">tu kinesiólogo</p>
              </div>
            </div>
          )}
        </div>

        {/* Chat */}
        <div className="flex-1 flex flex-col p-2 overflow-hidden">
          {!pacienteId ? (
            <div className="flex items-center justify-center py-12">
              <Loader2 className="w-6 h-6 animate-spin text-muted-foreground" />
            </div>
          ) : (
            <ChatConversation
              mensajes={mensajes.data ?? []}
              viewerRole="paciente"
              loading={mensajes.loading}
              fetchError={mensajes.error}
              sending={enviar.loading}
              sendError={enviar.error}
              onSend={async (content) => {
                const result = await enviar.enviar({
                  pacienteId,
                  sender: 'paciente',
                  content,
                });
                return result !== null;
              }}
              onMarkRead={() => {
                void marcar.marcar(pacienteId);
              }}
            />
          )}
        </div>
      </div>

      <PacienteBottomNav />
    </div>
  );
}
